// extracted by mini-css-extract-plugin
module.exports = {"textContent":"_1x2teo1nMddIEwnFo9BkQ6","modalTitle":"_30vVPlzMwFzs2YpbG5PnAR","kidImg":"_2phKg0djopWiNjjDMdDtGa"};